import { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import { useLocation } from "react-router-dom";

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location=useLocation()

  useEffect(()=>{
  
  },[])

  const links = [
    {name:"خانه",to:"/"},
    {name:"بار",to:"/cargo"},
    {name: "راننده",to:"/driver/cargo"},
    {name:"فروشگاه",to:"/market"},
    {name:"معامله و اجاره خودرو",to:"/ads"},
    {name: "درباره ما",to:"/about"},
    {name:"تماس با ما",to:"/contact"},

  ];

  return (
    <header className="min-w-full bg-white shadow-sm z-50 fixed">
      <div className="flex justify-between items-center px-4 h-[70px]">
        {/* لوگو */}
        <div className="w-[50px] h-full rounded-md overflow-hidden">
          <img
            className="w-full h-full object-contain"
            src="/icon-512.png"
            alt="Logo"
          />
        </div>

        {/* منو دسکتاپ */}
        <nav className="hidden md:flex w-full justify-center">
          <ul className="flex gap-8 text-gray-700 text-[12px] lg:text-[16px] ">
          {links.map((item, idx) => {
              const isActive = location.pathname === item.to;
              return (
                <li key={idx} className="relative group">
                  <Link
                    to={item.to}
                    className={`transition-all duration-200 hover:text-special hover:scale-105 
                      ${isActive ? "font-[16px] text-special" : ""}`}
                  >
                    {item.name}
                    <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-special group-hover:w-full transition-all duration-300"></span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

{/*       
        <div className="hidden md:flex gap-5 items-center text-[12px] lg:text-[16px]">
          <Link
            to="/login"
            className="px-4 py-1 border border-special rounded-md text-special hover:bg-special hover:text-white transition-colors duration-200"
          >
            ورود
          </Link>
          <Link
            to="/login"
            className="px-4 whitespace-nowrap truncate py-1 border border-special rounded-md text-special hover:bg-special hover:text-white transition-colors duration-200"
          >
            ثبت نام
          </Link>
        </div> */}

      
        <div className="md:hidden flex items-center">
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="text-gray-700 focus:outline-none text-2xl"
          >
            {mobileOpen ? <HiOutlineX /> : <HiOutlineMenu />}
          </button>
        </div>
      </div>

      {/* منو موبایل */}
      {mobileOpen && (
        <nav className="md:hidden bg-white   shadow-md">
          <ul className="flex flex-col gap-4 p-4 text-gray-700 ">
            {links.map((item, idx) => (
              <li onClick={()=>{setMobileOpen(false)}} key={idx} className="h-6 py-1">
                <Link
                  to={item.to}
                  className="block  border-special transition-all duration-200 hover:text-special hover:underline decoration-special underline-offset-4"
                >
                  {item.name}
                </Link>
              </li>
            ))}
            {/* <li  className="h-6 py-1" onClick={()=>{setMobileOpen(false)}}>
              <Link
                to="/login"
                className="px-4 py-1  border border-special rounded-md text-special hover:bg-special hover:text-white transition-colors duration-200"
              >
                ورود
              </Link> 
            
            </li>
            <li  className="h-6 py-1" onClick={()=>{setMobileOpen(false)}}>
            <Link
                to="/login"
                className="px-4 py-1 border border-special rounded-md text-special hover:bg-special hover:text-white transition-colors duration-200"
              >
                ثبت نام
              </Link>
            </li> */}
          </ul>
        </nav>
      )}
    </header>
  );
}
